import { useContext } from 'react'

import { ToastContext } from '@reveni-io/reveni-ui'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import UnsavedChangesAlert from '@/common/components/UnsavedChangesAlert/UnsavedChangesAlert'
import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import useTopBannerWidgetConfiguration from './hooks/useTopBannerWidgetConfiguration/useTopBannerWidgetConfiguration'
import TopBannerWidgetConfiguration from './TopBannerWidgetConfiguration/TopBannerWidgetConfiguration'
import TopBannerWidgetConfigurationPageSkeleton from './TopBannerWidgetConfigurationPageSkeleton/TopBannerWidgetConfigurationPageSkeleton'
import * as Styles from './styles'

const TopBannerWidgetConfigurationPage = () => {
  const { info } = useContext(AppContext)
  const { hasPermission } = useUserPermissions()
  const { setToastInfo } = useContext(ToastContext)
  const supportedLanguages = info?.selectedStore?.supported_languages || ['en']

  const {
    gettingTopBannerWidgetPreferences,
    applyingTopBannerWidgetPreferences,
    backgroundColor,
    setBackgroundColor,
    textColor,
    setTextColor,
    linkColor,
    setLinkColor,
    customTexts,
    setCustomTexts,
    useCustomText,
    setUseCustomText,
    hasChanges,
    revertChanges,
    scriptInfo,
    onSave,
  } = useTopBannerWidgetConfiguration({
    storeId: info.selectedStore.id,
    setToastInfo,
    supportedLanguages,
  })

  if (gettingTopBannerWidgetPreferences) {
    return <TopBannerWidgetConfigurationPageSkeleton />
  }

  return (
    <Styles.Container>
      {hasChanges && <UnsavedChangesAlert hasPermission={hasPermission(userPermissions.editExtra)} />}
      <TopBannerWidgetConfiguration
        backgroundColor={backgroundColor}
        onChangeBackgroundColor={setBackgroundColor}
        textColor={textColor}
        onChangeTextColor={setTextColor}
        linkColor={linkColor}
        onChangeLinkColor={setLinkColor}
        customTexts={customTexts}
        onChangeCustomTexts={setCustomTexts}
        useCustomText={useCustomText}
        onChangeUseCustomText={setUseCustomText}
        supportedLanguages={supportedLanguages}
        scriptInfo={scriptInfo}
      />
      <SaveChangesButtons
        hasChanges={hasPermission(userPermissions.editExtra) && hasChanges}
        onSave={onSave}
        onRevertChanges={revertChanges}
        loading={applyingTopBannerWidgetPreferences || gettingTopBannerWidgetPreferences}
        disabled={applyingTopBannerWidgetPreferences || gettingTopBannerWidgetPreferences}
      />
    </Styles.Container>
  )
}

export default TopBannerWidgetConfigurationPage
